export default __webpack_public_path__ + "static/media/custom_homes.881b58d2.png";